import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "../assets/css/HomePage.css";
import { cr1, cr2, cr3 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ---------- SEO helpers ---------- */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
// Порядок атрибутов: href → hreflang
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}
function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const Crazytime = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

  // Оставляю твою функцию, но SEO ниже использует универсальные setMetaName/Property
  function setMetaTag(name, content) {
    let element = document.querySelector(`meta[name="${name}"]`);
    if (element) {
      element.setAttribute("content", content);
    } else {
      element = document.createElement("meta");
      element.name = name;
      element.content = content;
      document.head.appendChild(element);
    }
  }

useEffect(() => {
  // базовые тексты (EN → BN перевод уже задан)
  const titleEN = "HHBD Crazy Time — Live Wheel Game & Bonus Rounds BD ";
  const descEN =
    "Join HHBD Crazy Time and enjoy the most exciting live casino show! Spin the wheel, play Cash Hunt & Coin Flip, and win BDT prizes instantly. Streamed live with real dealers and Bangla-friendly interaction.";

  const titleBN = "HHBD Crazy Time — লাইভ হুইল গেম এবং বোনাস রাউন্ডস BD";
  const descBN =
    "HHBD Crazy Time-এ যোগ দিন এবং সবচেয়ে উত্তেজনাপূর্ণ লাইভ ক্যাসিনো শো উপভোগ করুন! চাকা ঘুরান, ক্যাশ হান্ট এবং কয়েন ফ্লিপ খেলুন এবং তাৎক্ষণিকভাবে BDT পুরস্কার জিতে নিন। প্রকৃত ডিলার এবং বাংলা-বান্ধব ইন্টারঅ্যাকশনের সাথে লাইভ স্ট্রিম করা হয়েছে।";

  const keywordsEN =
    "HHBD Crazy Time, live wheel game BD, bonus wheel Bangladesh, Coin Flip BD, Cash Hunt game, real money live casino";
  const keywordsBN =
    "HHBD Crazy Time কয়েন ফ্লিপ, ক্যাশ হান্ট, লাইভ গেম, বোনাস রাউন্ড বাংলাদেশ, রিয়েল মানি গেম";

  const isBN = lang === "bn";

  // Тайтл должен быть В UPPERCASE везде (document.title, OG, Twitter)
  const pageTitle = (isBN ? titleBN : titleEN).toUpperCase();
  const pageDesc = isBN ? descBN : descEN;           // description НЕ в верхнем регистре
  const pageKeywords = isBN ? keywordsBN : keywordsEN; // keywords НЕ в верхнем регистре

  // применим и твою setMetaTag, и наши, чтобы не ломать существующее
  document.title = pageTitle;            // ✅ UPPERCASE
  setMetaTag("description", pageDesc);   // обычный регистр
  setMetaTag("keywords", pageKeywords);  // обычный регистр

  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // hreflang альтернативы
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  // Canonical + hreflang (+ x-default)
  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // -------- Open Graph --------
  const ogImage = toAbsoluteUrl(cr1);
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);        // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc);   // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? titleBN : titleEN); // alt — читаемый текст
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // -------- Twitter (полный блок) --------
  const twitterSite = "@HHBD_official";     // замени на реальный @ бренда
  const twitterCreator = "@HHBD_official";  // замени при необходимости
  const twitterImageAlt = isBN
    ? "HHBD Crazy Time-এ যোগ দিন - রঙিন লাইভ হুইল ঘোরান, মাল্টিপ্লায়ার মারুন এবং এই ইন্টারেক্টিভ গেম শোতে বড় জয় পান।"
    : "Join HHBD Crazy Time – spin the colorful live wheel, hit multipliers and win big in this interactive game show.";

  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);        // ✅ UPPERCASE
  setMetaName("twitter:description", pageDesc);   // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);      // ✅ добавили URL сайта
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);

  // Доп. пары (до 2-х)
  setMetaName("twitter:label1", isBN ? "বোনাস মোড" : "Bonus Modes");
  setMetaName(
    "twitter:data1",
    isBN ? "Coin Flip, Cash Hunt, Pachinko, Crazy Time" : "Coin Flip, Cash Hunt, Pachinko, Crazy Time"
  );
  setMetaName("twitter:label2", isBN ? "প্ল্যাটফর্ম" : "Platform");
  setMetaName("twitter:data2", "Android");


  
}, [lang, pathname]);


  return (
    <>
      {/* --- ENGLISH VERSION --- */}
      <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = lang === "bn";
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/crazytime";

      // Page copy (names/descriptions in JSON-LD must be UPPERCASE per your rule)
      const titleEN = "HHBD Crazy Time — Live Wheel Game & Bonus Rounds BD ";
      const descEN =
        "Join HHBD Crazy Time and enjoy the most exciting live casino show! Spin the wheel, play Cash Hunt & Coin Flip, and win BDT prizes instantly. Streamed live with real dealers and Bangla-friendly interaction.";

      const titleBN = "HHBD Crazy Time — লাইভ হুইল গেম এবং বোনাস রাউন্ডস BD";
      const descBN =
        "HHBD Crazy Time-এ যোগ দিন এবং সবচেয়ে উত্তেজনাপূর্ণ লাইভ ক্যাসিনো শো উপভোগ করুন! চাকা ঘুরান, ক্যাশ হান্ট এবং কয়েন ফ্লিপ খেলুন এবং তাৎক্ষণিকভাবে BDT পুরস্কার জিতে নিন। প্রকৃত ডিলার এবং বাংলা-বান্ধব ইন্টারঅ্যাকশনের সাথে লাইভ স্ট্রিম করা হয়েছে।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps  = (isBN ? descBN  : descEN );
      const inLang = isBN ? "bn" : "en";


      // Use cr1 as primary image; fall back to favicon if needed
      const ogImage =
        typeof cr1 === "string"
          ? (/^https?:\/\//i.test(cr1) ? cr1 : `${origin}${cr1.startsWith("/") ? "" : "/"}${cr1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": "HHBD", "url": origin },
          "primaryImageOfPage": ogImage
        },

        // Organization
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": pageTitleCaps,
  "url": origin,
  "description": pageDescCaps,
  "logo": {cr1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

},

        // MobileApplication (no downloadUrl as requested)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "HHBD APP",
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": ogImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            
          },
          "publisher": {
            "@type": "Organization",
            "name": "HHBD",
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {lang === "en" && (
  <>
    <section className="zHHBD-crazyhero">
      {/* Layered stage lights */}
      <div className="zHHBD-crazyhero__spot zHHBD-crazyhero__spot--l"></div>
      <div className="zHHBD-crazyhero__spot zHHBD-crazyhero__spot--r"></div>
      {/* Floating confetti strips */}
      <div className="zHHBD-crazyhero__confetti">
        <span className="strip strip--1"></span>
        <span className="strip strip--2"></span>
        <span className="strip strip--3"></span>
        <span className="strip strip--4"></span>
        <span className="strip strip--5"></span>
      </div>
      {/* Background image & overlay */}
      <div className="zHHBD-crazyhero__bg">
        <div className="zHHBD-crazyhero__overlay"></div>
      </div>
      <div className="zHHBD-crazyhero__container">
        <div className="zHHBD-crazyhero__content">
          <h1 className="zHHBD-crazyhero__title">
            HHBD Crazy Time – Spin & Win Live in Bangladesh
          </h1>
          <p className="zHHBD-crazyhero__desc">
            Step into the spotlight with Crazy Time, a live, interactive extravaganza that outshines a regular{" "}
            <Link to="/casino" className="zHHBD-crazyhero__link">casino</Link> title. Center stage is a giant prize wheel,
            supercharged by a Top Slot that can attach extra multipliers, and powered by four heart-racing bonus{" "}
            <Link to="/games" className="zHHBD-crazyhero__link">games</Link> — every spin kicks off a fresh burst of drama,
            variety, and surprise from the very first second.
          </p>
          {/* CTA buttons */}
          <div className="zHHBD-crazyhero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-crazyhero__btn zHHBD-crazyhero__btn--main"
              title="Feel the studio buzz and jump straight into a live round this moment"
            >
              Dive Into the Show
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-crazyhero__btn zHHBD-crazyhero__btn--ghost"
              title="Grab the official HHBD app for instant Crazy Time access anywhere you go"
            >
              Download the App
            </a>
          </div>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Crazy Time — the ultimate live online game-show adventure"
        >
          <img
            src={cr1}
            alt="A cheerful cartoon Bengal tiger — HHBD’s mascot — dressed as a vibrant game-show host in a bold suit, holding a microphone with flair."
            title="HHBD Crazy Time — a colorful studio spectacle with a colossal wheel and nonstop energy"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-crazywhy2">
      {/* Animated background flares */}
      <div className="zHHBD-crazywhy2__flare zHHBD-crazywhy2__flare--left"></div>
      <div className="zHHBD-crazywhy2__flare zHHBD-crazywhy2__flare--right"></div>
      <div className="zHHBD-crazywhy2__wrapper">
        {/* LEFT: Visual */}
        <div className="zHHBD-crazywhy2__visual">
          <figure className="zHHBD-crazywhy2__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Crazy Time — Pick up the basics and enter the live show"
            >
              <img
                src={cr2}
                alt="A stylish young woman lighting up with excitement as she watches Crazy Time, the vivid bonus wheel glowing on her display."
                title="HHBD Crazy Time — Getting started with the live game-show format"
                className="zHHBD-crazywhy2__img"
              />
            </a>
          </figure>
        </div>
        {/* RIGHT: Content */}
        <div className="zHHBD-crazywhy2__content">
          <div className="zHHBD-crazywhy2__inner">
            <h2 className="zHHBD-crazywhy2__title">
              What Is Crazy Time?
            </h2>
            <div className="zHHBD-crazywhy2__text">
              <p>
                Crazy Time is a fast-moving live online show built around a towering, vertical money wheel.
                A real host spins each round while you back the segment you believe will hit.
                It’s simple to grasp yet packed with spectacle, variety, and constant entertainment.
              </p>
              <p>
                Before the wheel turns, the two-reel “Top Slot” can pair a random multiplier with a chosen segment,
                unlocking the chance for oversized returns even in base play. The true fireworks ignite in four
                signature bonus rounds where pace, showmanship, and payout potential ramp up dramatically.
              </p>
              <p>
                The broadcast streams live in crisp HD from a cutting-edge studio.
                Charismatic presenters and saturated set design create a party mood, making it one of the most engaging{" "}
                <Link to="/casino" className="zHHBD-crazywhy2__link">casino</Link>{" "}
                <Link to="/games" className="zHHBD-crazywhy2__link">games</Link> on HHBD.
                Chat in real time with the host and fellow players — that social layer adds a buzz that lifts every round.
              </p>
            </div>
            <div className="zHHBD-crazywhy2__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-crazywhy2__btn"
                title="Jump into a Crazy Time round now and feel the live-show rush"
              >
                Join a Crazy Time Round Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-wheelinfo">
      {/* Aurora ribbons */}
      <div className="zHHBD-wheelinfo__aurora zHHBD-wheelinfo__aurora--l"></div>
      <div className="zHHBD-wheelinfo__aurora zHHBD-wheelinfo__aurora--r"></div>
      {/* Section heading */}
      <h2 className="zHHBD-wheelinfo__title">
        The Four Unmissable Bonus Experiences
      </h2>
      <p>
        {/* В этом блоке нет соответствующего вводного абзаца в <main> для данной секции — оставляем пустым. */}
      </p>
      <div className="zHHBD-wheelinfo__container">
        {/* LEFT COLUMN */}
        <div className="zHHBD-wheelinfo__col zHHBD-wheelinfo__col--center">
          <figure className="zHHBD-wheelinfo__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Crazy Time — A look at the bonus rounds and how they work"
            >
              <img
                src={cr3}
                alt="A delighted young woman watching Crazy Time as the colorful wheel blazes; pure anticipation across her face."
                title="HHBD Crazy Time — Exploring the live bonus features up close"
                className="zHHBD-wheelinfo__img"
              />
            </a>
          </figure>
        </div>
        <div className="zHHBD-wheelinfo__col zHHBD-wheelinfo__col--left">
          <p className="zHHBD-wheelinfo__box">
            <span className="zHHBD-wheelinfo__mark">Cash Hunt</span>
            An arcade-style rapid shootout featuring a huge grid packed with 108 hidden multipliers.
            After a shuffle, icons obscure the values. Aim the cannon, lock your pick, and reveal your prize —
            a punchy, cinematic unveil that lands in an instant.
          </p>
          <p className="zHHBD-wheelinfo__box">
            <span className="zHHBD-wheelinfo__mark">Pachinko</span>
            A towering pegboard drops, and a puck tumbles from above. Your payout equals the multiplier where the puck settles.
            Hit “Double” to boost every value and repeat the drop — creating thrilling, compounding cascades of potential.
          </p>
        </div>
        {/* CENTER IMAGE */}
        {/* RIGHT COLUMN */}
        <div className="zHHBD-wheelinfo__col zHHBD-wheelinfo__col--right">
          <p className="zHHBD-wheelinfo__box">
            <span className="zHHBD-wheelinfo__mark">Coin Flip</span>
            A red-and-blue coin is assigned two different multipliers — one per side — then flipped live.
            You take the value linked to the face that lands up. It’s lightning-quick, crystal clear, and decisively fun.
          </p>
          <p className="zHHBD-wheelinfo__box">
            <span className="zHHBD-wheelinfo__mark">Crazy Time</span>
            The headline round. The presenter steps into a vivid virtual world with a massive money wheel.
            Pick your flapper — green, blue, or yellow — and claim the multiplier where it stops.
            Land “Double” or “Triple” to lift all values and keep spinning — paving the way for staggering totals.
          </p>
        </div>
      </div>
      <div className="zHHBD-wheelinfo__cta">
        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-wheelinfo__btn"
          title="Enter a Crazy Time session and sample each bonus mode live"
        >
          Join a Crazy Time Round
        </a>
      </div>
    </section>

    <section className="zHHBD-bonuscards">
      {/* Floating spark particles */}
      <div className="zHHBD-bonuscards__spark zHHBD-bonuscards__spark--1"></div>
      <div className="zHHBD-bonuscards__spark zHHBD-bonuscards__spark--2"></div>
      <div className="zHHBD-bonuscards__spark zHHBD-bonuscards__spark--3"></div>
      {/* Section heading */}
      <h2 className="zHHBD-bonuscards__heading">
        Why Players Across Bangladesh Love Crazy Time
      </h2>
      {/* Introductory text */}
      <div className="zHHBD-bonuscards__content">
        <p>
          Crazy Time has exploded in popularity in Bangladesh because it marries ultra-simple rules with the live thrills of a
          TV-style production. The joy isn’t just the outcome — it’s the suspense of the spinning wheel,
          the charisma of the hosts, and the shared buzz of a studio broadcast. Anyone can jump in, with or without{" "}
          <Link to="/casino" className="zHHBD-bonuscards__link">casino</Link> experience, and feel involved right away.
        </p>
        <p>
          The magnetism of towering multipliers inside the bonus{" "}
          <Link to="/games" className="zHHBD-bonuscards__link">games</Link> is huge.
          Turning a modest stake into a headline-worthy result keeps attention locked. The interactive choices — where
          your input shapes parts of the round — add real agency and tension. Most importantly, the communal rush of
          playing with thousands, cheering big hits in chat, and reacting together live makes Crazy Time at HHBD
          a genuinely social, high-energy ride from first spin to final reveal.
        </p>
      </div>
      {/* CTA */}
      <a
        href="https://haruvest.com/W7DZsfpK"
        className="zHHBD-bonuscards__btn"
        title="Enter a Crazy Time show right now and play along with the live studio"
      >
        Enter a Live Crazy Time Show
      </a>
    </section>
  </>


      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
 <>
    <section className="zHHBD-crazyhero">
      {/* স্তরায়িত স্টেজ লাইট */}
      <div className="zHHBD-crazyhero__spot zHHBD-crazyhero__spot--l"></div>
      <div className="zHHBD-crazyhero__spot zHHBD-crazyhero__spot--r"></div>
      {/* ভাসমান কনফেটি স্ট্রিপস */}
      <div className="zHHBD-crazyhero__confetti">
        <span className="strip strip--1"></span>
        <span className="strip strip--2"></span>
        <span className="strip strip--3"></span>
        <span className="strip strip--4"></span>
        <span className="strip strip--5"></span>
      </div>
      {/* ব্যাকগ্রাউন্ড ইমেজ ও ওভারলে */}
      <div className="zHHBD-crazyhero__bg">
        <div className="zHHBD-crazyhero__overlay"></div>
      </div>
      <div className="zHHBD-crazyhero__container">
        <div className="zHHBD-crazyhero__content">
          <h1 className="zHHBD-crazyhero__title">
            HHBD Crazy Time – বাংলাদেশে স্পিন অ্যান্ড উইন লাইভ
          </h1>
          <p className="zHHBD-crazyhero__desc">
            Crazy Time-এর আলোয় মঞ্চে উঠুন — লাইভ, ইন্টারঅ্যাকটিভ এক জাঁকজমকপূর্ণ শো, যা সাধারণ{" "}
            <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> টাইটেলকে ছাড়িয়ে যায়।
            কেন্দ্রে রয়েছে এক বিশাল প্রাইজ হুইল, যেটিকে টপ স্লট অতিরিক্ত মাল্টিপ্লায়ার জুড়ে সুপারচার্জ করতে পারে,
            এবং চারটি রোমহর্ষক বোনাস{" "}
            <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> দ্বারা চালিত —
            প্রতিটি স্পিনের প্রথম সেকেন্ড থেকেই শুরু হয় নতুন নাটকীয়তা, বৈচিত্র্য ও চমকের বিস্ফোরণ।
          </p>
          {/* সিটিএ বোতাম */}
          <div className="zHHBD-crazyhero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-crazyhero__btn zHHBD-crazyhero__btn--main"
              title="স্টুডিওর উচ্ছ্বাস অনুভব করুন এবং ঠিক এখনই একটি লাইভ রাউন্ডে ঝাঁপ দিন"
            >
              শো-তে ডুব দিন
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-crazyhero__btn zHHBD-crazyhero__btn--ghost"
              title="অফিশিয়াল HHBD অ্যাপ নিন — যেখানেই যান Crazy Time-এ তৎক্ষণাৎ প্রবেশ"
            >
              অ্যাপ ডাউনলোড করুন
            </a>
          </div>
        </div>
        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Crazy Time — লাইভ অনলাইন গেম-শোর চূড়ান্ত অ্যাডভেঞ্চার"
        >
          <img
            src={cr1}
            alt="আনন্দিত কার্টুন বেঙ্গল টাইগার — HHBD-এর মাসকট — উজ্জ্বল স্যুটে প্রাণবন্ত গেম-শো হোস্টের সাজে, হাতে মাইক্রোফোন।"
            title="HHBD Crazy Time — বিশাল হুইল ও অবিরাম এনার্জির বর্ণিল স্টুডিও স্পেক্ট্যাকল"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-crazywhy2">
      {/* অ্যানিমেটেড ব্যাকগ্রাউন্ড ফ্লেয়ার */}
      <div className="zHHBD-crazywhy2__flare zHHBD-crazywhy2__flare--left"></div>
      <div className="zHHBD-crazywhy2__flare zHHBD-crazywhy2__flare--right"></div>
      <div className="zHHBD-crazywhy2__wrapper">
        {/* বাম: ভিজ্যুয়াল */}
        <div className="zHHBD-crazywhy2__visual">
          <figure className="zHHBD-crazywhy2__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Crazy Time — বেসিকস শিখুন এবং লাইভ শোতে ঢুকে পড়ুন"
            >
              <img
                src={cr2}
                alt="এক স্টাইলিশ তরুণী উচ্ছ্বাসে উজ্জ্বল — স্ক্রিনে Crazy Time দেখছেন, উজ্জ্বল বোনাস হুইলটি স্পষ্টভাবে জ্বলজ্বল করছে।"
                title="HHBD Crazy Time — লাইভ গেম-শো ফরম্যাটে শুরু করার গাইড"
                className="zHHBD-crazywhy2__img"
              />
            </a>
          </figure>
        </div>
        {/* ডান: কনটেন্ট */}
        <div className="zHHBD-crazywhy2__content">
          <div className="zHHBD-crazywhy2__inner">
            <h2 className="zHHBD-crazywhy2__title">
              Crazy Time কী?
            </h2>
            <div className="zHHBD-crazywhy2__text">
              <p>
                Crazy Time হলো এক দ্রুতগতির লাইভ অনলাইন শো, যা এক উঁচু, উল্লম্ব মানি হুইলকে কেন্দ্র করে।
                একজন বাস্তব হোস্ট প্রতিটি রাউন্ডে হুইল ঘোরান, আর আপনি অনুমিত সেগমেন্টে বেট রাখেন।
                বুঝতে সহজ, কিন্তু দারুণ দৃশ্য-জৌলুস, বৈচিত্র্য ও নিরবচ্ছিন্ন বিনোদনে ভরপুর।
              </p>
              <p>
                হুইল ঘোরার আগেই দুই-রিল “টপ স্লট” কোনো একটি সেগমেন্টের সাথে র‍্যান্ডম মাল্টিপ্লায়ার জুড়তে পারে,
                ফলে বেস প্লেতেও বড় রিটার্নের সম্ভাবনা খুলে যায়। সত্যিকারের আতশবাজি জ্বলে ওঠে চারটি
                স্বাক্ষর বোনাস রাউন্ডে, যেখানে গতি, শোম্যানশিপ এবং পেআউট সম্ভাবনা নাটকীয়ভাবে বেড়ে যায়।
              </p>
              <p>
                সম্প্রচারটি অত্যাধুনিক স্টুডিও থেকে ক্রিস্প এইচডিতে লাইভ স্ট্রিম হয়।
                ক্যারিশম্যাটিক প্রেজেন্টার আর স্যাচুরেটেড সেট ডিজাইন তৈরি করে পার্টি-মুড, যা এটিকে HHBD-এর সবচেয়ে আকর্ষণীয়{" "}
                <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link>{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>গুলোর একটি বানিয়েছে।
                বাস্তব সময়ে হোস্ট ও সহখেলোয়াড়দের সাথে চ্যাট করুন — এই সোশ্যাল স্তরই প্রতিটি রাউন্ডে বাড়তি উৎসাহ যোগ করে।
              </p>
            </div>
            <div className="zHHBD-crazywhy2__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-crazywhy2__btn"
                title="এখনই একটি Crazy Time রাউন্ডে যোগ দিয়ে লাইভ-শোর রাশ অনুভব করুন"
              >
                এখনই একটি Crazy Time রাউন্ডে যোগ দিন
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="zHHBD-wheelinfo">
      {/* অরোরা রিবন */}
      <div className="zHHBD-wheelinfo__aurora zHHBD-wheelinfo__aurora--l"></div>
      <div className="zHHBD-wheelinfo__aurora zHHBD-wheelinfo__aurora--r"></div>
      {/* সেকশন শিরোনাম */}
      <h2 className="zHHBD-wheelinfo__title">
        চারটি অনবদ্য বোনাস অভিজ্ঞতা
      </h2>
      <p>
        {/* <main>-এ এই সেকশনের জন্য সমতুল্য ইনট্রো অনুচ্ছেদ নেই — তাই খালি রাখা হলো। */}
      </p>
      <div className="zHHBD-wheelinfo__container">
        {/* বাম কলাম (সেন্টার ইমেজ) */}
        <div className="zHHBD-wheelinfo__col zHHBD-wheelinfo__col--center">
          <figure className="zHHBD-wheelinfo__figure">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Crazy Time — বোনাস রাউন্ডসমূহ ও সেগুলো কীভাবে কাজ করে"
            >
              <img
                src={cr3}
                alt="উদ্দীপনায় ভরা এক তরুণী Crazy Time দেখছেন; রঙিন হুইল জ্বলে উঠেছে — তার মুখে টানটান আশা।"
                title="HHBD Crazy Time — লাইভ বোনাস ফিচারগুলি কাছ থেকে দেখা"
                className="zHHBD-wheelinfo__img"
              />
            </a>
          </figure>
        </div>
        <div className="zHHBD-wheelinfo__col zHHBD-wheelinfo__col--left">
          <p className="zHHBD-wheelinfo__box">
            <span className="zHHBD-wheelinfo__mark">Cash Hunt</span>
            আর্কেড-স্টাইলের দ্রুতগতি শ্যুটআউট — এক বিশাল গ্রিডে লুকানো ১০৮টি মাল্টিপ্লায়ার।
            শাফল শেষে আইকনগুলো মান লুকিয়ে ফেলে। কামান তাক করুন, আপনার পছন্দ লক করুন, আর মুহূর্তেই উন্মোচিত হবে পুরস্কার —
            ঝকঝকে, সিনেমাটিক এক রিভিল।
          </p>
          <p className="zHHBD-wheelinfo__box">
            <span className="zHHBD-wheelinfo__mark">Pachinko</span>
            এক সুউচ্চ পেগবোর্ড নামে, আর ওপরে থেকে একটি পাক পড়ে। পাকটি যেখানে থামে, সেই মাল্টিপ্লায়ারই আপনার পেআউট।
            “Double” লাগলে সব মান দ্বিগুণ, তারপর আবার ড্রপ — সম্ভাবনার রোমাঞ্চকর ক্যাসকেড জেগে ওঠে।
          </p>
        </div>
        {/* ডান কলাম */}
        <div className="zHHBD-wheelinfo__col zHHBD-wheelinfo__col--right">
          <p className="zHHBD-wheelinfo__box">
            <span className="zHHBD-wheelinfo__mark">Coin Flip</span>
            লাল-নীল দুটি পাশের কয়েনে দুই রকম মাল্টিপ্লায়ার সেট হয় — প্রতিটি পাশে একট করে — তারপর লাইভ ফ্লিপ।
            যে পিঠ ওপরে থাকে, সেই মানটাই আপনার। চোখের পলকে মিটে যায় — স্পষ্ট, দ্রুত, আর দারুণ মজার।
          </p>
          <p className="zHHBD-wheelinfo__box">
            <span className="zHHBD-wheelinfo__mark">Crazy Time</span>
            শিরোনামের রাউন্ড। প্রেজেন্টার ঢুকে পড়েন এক জীবন্ত ভার্চুয়াল সেটে, বিশাল মানি হুইলসহ।
            আপনার ফ্ল্যাপার বাছুন — সবুজ, নীল বা হলুদ — আর যেখানে থামে, সেই মাল্টিপ্লায়ারই ক্লেইম করুন।
            “Double” বা “Triple” লাগলে সব মান বেড়ে যায় এবং স্পিন চলতেই থাকে — পথ খুলে যায় বিস্ময়কর টোটালের দিকে।
          </p>
        </div>
      </div>
      <div className="zHHBD-wheelinfo__cta">
        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-wheelinfo__btn"
          title="একটি Crazy Time সেশনে ঢুকে লাইভে প্রতিটি বোনাস মোড আজই ট্রাই করুন"
        >
          একটি Crazy Time রাউন্ডে যোগ দিন
        </a>
      </div>
    </section>

    <section className="zHHBD-bonuscards">
      {/* ভাসমান স্পার্ক কণিকা */}
      <div className="zHHBD-bonuscards__spark zHHBD-bonuscards__spark--1"></div>
      <div className="zHHBD-bonuscards__spark zHHBD-bonuscards__spark--2"></div>
      <div className="zHHBD-bonuscards__spark zHHBD-bonuscards__spark--3"></div>
      {/* সেকশন শিরোনাম */}
      <h2 className="zHHBD-bonuscards__heading">
        কেন বাংলাদেশজুড়ে খেলোয়াড়রা Crazy Time-এ মুগ্ধ
      </h2>
      {/* ভূমিকা */}
      <div className="zHHBD-bonuscards__content">
        <p>
          বাংলাদেশে Crazy Time দ্রুত জনপ্রিয় হয়েছে, কারণ এটি অত্যন্ত সহজ নিয়মকে লাইভ টিভি-স্টাইল প্রোডাকশনের রোমাঞ্চের সঙ্গে মিলিয়ে দেয়।
          আনন্দটা শুধু ফলাফলে নয় — ঘূর্ণায়মান হুইলের টানটান সাসপেন্সে, হোস্টদের ক্যারিশমায়,
          আর স্টুডিও ব্রডকাস্টের শেয়ার্ড পরিবেশে। কারও{" "}
          <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> অভিজ্ঞতা থাক বা না থাক,
          যে কেউ ঝটপট ঢুকে পড়ে তৎক্ষণাৎ সংযুক্ত অনুভব করতে পারেন।
        </p>
        <p>
          বোনাস{" "}
          <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link>-এর ভেতরের উঁচু মাল্টিপ্লায়ারের আকর্ষণ বিশাল।
          ছোট স্টেককে হেডলাইন-যোগ্য ফলে তুলতে পারা মনোযোগ গেঁথে রাখে। ইন্টারঅ্যাকটিভ চয়েস — যেখানে আপনার ইনপুট রাউন্ডের কিছু অংশ গঠন করে —
          দেয় বাস্তব এজেন্সি ও টেনশন। সবচেয়ে বড় কথা, হাজারো খেলোয়াড়ের সাথে একসাথে খেলা, চ্যাটে বড় হিট উদযাপন,
          আর লাইভে মিলেমিশে প্রতিক্রিয়া — HHBD-তে Crazy Time-কে করে তোলে সত্যিকারের সামাজিক, হাই-এনার্জি রাইড,
          প্রথম স্পিন থেকে শেষ উন্মোচন পর্যন্ত।
        </p>
      </div>
      {/* সিটিএ */}
      <a
        href="https://haruvest.com/W7DZsfpK"
        className="zHHBD-bonuscards__btn"
        title="একটি লাইভ Crazy Time শো-তে এখনই প্রবেশ করে স্টুডিওর সাথে খেলুন"
      >
        লাইভ Crazy Time শো-তে প্রবেশ করুন
      </a>
    </section>
  </>


      )}
    </>
  );
};

export default Crazytime;
